<template>
  <v-container fluid grid-list-md class="px-0">
    <v-card>
      <v-card-title class="grey lighten-4 py-0">
        <span class="title primary--text">About Me</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat icon @click.native="editMode=true" v-show="!editMode">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn color="primary" outline round @click.native="cancelForm" v-show="editMode">Reset</v-btn>
        <v-btn color="primary" round @click.native="saveAboutMe" v-show="editMode">Save</v-btn>
      </v-card-title>
      <v-card-text class="">
        <v-container fluid class="pa-0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-textarea v-model="profile.summary" label="Summary" rows="3" :counter="512" :rules="rules.summary"
              :box="editMode" :readonly="!editMode">
            </v-textarea>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="profile.startedFreelancingYear" label="When did you start freelancing - Year" mask="####"
              :class="{'input-group--focused': editMode}" :readonly="!editMode" :box="editMode">
              </v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="profile.totalTrainingExperience" label="Year(s) of training experience" min="0" mask="##" :class="{'input-group--focused': editMode}" :readonly="!editMode" :box="editMode">
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
/* globals Store */
import { mapState } from 'vuex'
export default {
  name: 'AboutMeCard',
  data () {
    return {
      editMode: false,
      rules: {
        isRequired: [
          (v) => !!v || 'Required'
        ],
        summary: [
          (v) => (v.length <= 512) || 'summary must be less than 512 characters'
        ]
      }
    }
  },
  computed: {
    ...mapState('profile', {
      profile: 'profile'
    })
  },
  methods: {
    cancelForm () {
      // this.profile.summary = Store.state.profile.profile.summary
      console.log('i am called')
      Store.dispatch('profile/getProfile')
      this.editMode = false
    },
    saveAboutMe () {
      const profile = { ...this.profile }
      Store.dispatch('profile/saveProfile', profile)
      this.editMode = false
    }
  },
  created () {
    Store.dispatch('profile/getProfile')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AboutMeCard.vue